<template>
  <div :style="'padding 10px;position: relative;width: 100%;min-height: 100%;' + getSimulatorBodyStyle(ui.background)">
    <div style="padding: 10px;" v-if="isPost">
      <Alert show-icon>你于{{ postAt }}已经提交过了！</Alert>
    </div>
    <div v-if="!loadding">
      <div v-if="ui.header" v-html="getSimulatorBodyItem(ui.header)"></div>
      <van-row style="padding: 0 10px;">
        <van-col v-show="isShow(item)" span="24" v-for="(item, idx) in question" :key="idx" class="m-b">
          <div class="kk-title16">
            <span class="c-red" v-show="item.required">*</span>
            {{ item.title }}
          </div>
          <div class="kk-content" v-if="item.from_type === 'user_name'">
            {{ post[idx].value['昵称'] }}（{{ post[idx].value['部门'] }}）
          </div>
          <div class="kk-content" v-if="item.from_type === 'radio'">
            <RadioGroup v-model="post[idx].value[item.title]" @on-change="checkPost(idx)">
              <label v-for="(enumeration, i) in item.value_enumeration" :key="i">
                <Radio :label="enumeration" v-if="!item.images[i]">
                  {{ enumeration }}
                </Radio>
                <Input v-model="post[idx].extra[enumeration]" v-if="!item.images[i] && item.inputs && item.inputs[i]" class="w-100 m-r-xs" @on-change="checkPost(idx)" />
                <span v-if="!item.images[i] && item.inputs && item.inputs[i] && item.inputs_required && item.inputs_required[i]" class="c-red m-r-xs">*</span>
                <div :class="'item-box text-' + (item.img_locals ? item.img_locals[i] : '')" v-if="item.images[i]">
                  <img v-if="item.img_locals && myLocalStringToStr(item.img_locals[i], 0) === 'bottom'" :src="item.images[i]" style="width: 100%;" />
                  <Radio :label="enumeration">{{ enumeration }}</Radio>
                  <Input v-model="post[idx].extra[enumeration]" v-if="item.inputs && item.inputs[i]" class="w-100 m-r-xs" @on-change="checkPost(idx)" />
                  <span v-if="item.inputs && item.inputs[i] && item.inputs_required && item.inputs_required[i]" class="c-red">*</span>
                  <img v-if="item.img_locals && myLocalStringToStr(item.img_locals[i], 0) === 'top'" :src="item.images[i]" style="width: 100%; margin-top: 5px;" />
                </div>
              </label>
            </RadioGroup>
          </div>
          <div class="kk-content" v-if="item.from_type === 'checkbox'">
            <CheckboxGroup v-model="post[idx].value[item.title]" @on-change="checkPost(idx)">
              <label v-for="(enumeration, i) in item.value_enumeration" :key="i">
                <Checkbox :label="enumeration" v-if="!item.images[i]">
                  {{ enumeration }}
                </Checkbox>
                <Input v-model="post[idx].extra[enumeration]" v-if="!item.images[i] && item.inputs && item.inputs[i]" class="w-100 m-r-xs" @on-change="checkPost(idx)" />
                <span v-if="!item.images[i] && item.inputs && item.inputs[i] && item.inputs_required && item.inputs_required[i]" class="c-red m-r-xs">*</span>
                <div :class="'item-box text-' + (item.img_locals ? item.img_locals[i] : '')" v-if="item.images[i]">
                  <img v-if="item.img_locals && myLocalStringToStr(item.img_locals[i], 0) === 'bottom'" :src="item.images[i]" style="width: 100%;" />
                  <Checkbox :label="enumeration">{{ enumeration }}</Checkbox>
                  <Input v-model="post[idx].extra[enumeration]" v-if="item.inputs && item.inputs[i]" class="w-100 m-r-xs" @on-change="checkPost(idx)" />
                  <span v-if="item.inputs && item.inputs[i] && item.inputs_required && item.inputs_required[i]" class="c-red">*</span>
                  <img v-if="item.img_locals && myLocalStringToStr(item.img_locals[i], 0) === 'top'" :src="item.images[i]" style="width: 100%; margin-top: 5px;" />
                </div>
              </label>
            </CheckboxGroup>
          </div>
          <div class="kk-content" v-if="item.from_type === 'select'">
            <Select v-model="post[idx].value[item.title]" @on-change="checkPost(idx)">
              <Option :value="enumeration" v-for="(enumeration, i) in item.value_enumeration" :key="i">{{ enumeration }}</Option>
            </Select>
          </div>
          <div class="kk-content" v-if="item.from_type === 'date'">
            <DatePicker v-model="post[idx].value[item.title]" type="date" @on-change="checkPost(idx)"></DatePicker>
          </div>
          <div class="kk-content" v-if="item.from_type === 'time'">
            <TimePicker v-model="post[idx].value[item.title]" type="time" @on-change="checkPost(idx)"></TimePicker>
          </div>
          <div class="kk-content" v-if="item.from_type === 'input' && item.value_check">
            <Input v-model="post[idx].value[item.title]" :type="(formatList[item.value_check.format] && formatList[item.value_check.format].number) ? 'tel' : 'text'" @on-change="checkPost(idx)" />
          </div>
          <div class="kk-content" v-if="item.from_type === 'input' && !item.value_check">
            <Input v-model="post[idx].value[item.title]" @on-change="checkPost(idx)" />
          </div>
          <div class="kk-content" v-if="item.from_type === 'text'">
            <Input v-model="post[idx].value[item.title]" type="textarea" @on-change="checkPost(idx)" />
          </div>
          <div class="kk-content" v-if="item.from_type === 'address'">
            <select-address :project-id="projectId" :apiroot="apiroot" :member="member" :address-data="post[idx].value" :idx="idx" :title-key="item.title" :on-change="checkPost"></select-address>
          </div>
          <div class="kk-content" v-if="item.from_type === 'rate'">
            <Rate v-model="post[idx].value[item.title]" @on-change="checkPost(idx)" />
          </div>
          <div class="kk-content" v-if="item.from_type === 'remarks'" v-html="item.remarks"></div>
          <div v-if="checkList['r_' + idx]">
            <Alert type="error" show-icon>{{ checkList['r_' + idx] }}</Alert>
          </div>
        </van-col>
      </van-row>
      <div style="margin: 16px">
        <van-button @click="submit" round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
      <div v-if="getSimulatorBodyItem(ui.footer) === ''">&nbsp;</div>
      <div v-if="ui.footer" v-html="getSimulatorBodyItem(ui.footer)"></div>
    </div>
  </div>
</template>
<script>
import { Toast, Notify } from 'vant'
import { getSimulatorBodyStyle, getSimulatorBodyItem } from '@/libs/tool'
import { SelectAddress } from '@/components/member-address'

var rootUrl = process.env.NODE_ENV === 'development' ? 'http://local.share.com' : ''
export default {
  name: 'app',
  components: {
    SelectAddress
  },
  data () {
    return {
      apiroot: rootUrl,
      isPost: false,
      postAt: '',
      loadding: true,
      projectId: null,
      projectUid: null,
      project: {},
      authorize: {},
      formwork: '',
      formwork_attr: '',
      member: {},
      ui: {
        background: {}
      },
      question: [],
      checkList: {},
      post: [],
      formatList: {}
    }
  },
  watch: {
  },
  methods: {
    myLocalStringToStr (string, idx) {
      if (typeof string === 'string') {
        var list = string.split('-')
        return list[idx]
      }
      return 'top'
    },
    inArray (search, array) {
      for (var i in array) {
        if (array[i] === search) {
          return true
        }
      }
      return false
    },
    getSimulatorBodyStyle (background) {
      return getSimulatorBodyStyle(background)
    },
    getSimulatorBodyItem (obj) {
      return getSimulatorBodyItem(obj)
    },
    checkRelevance (question, data, relevance) {
      switch (question.from_type) {
        case 'radio':
          if (this.inArray(data.value[question.title], relevance.value)) {
            return true
          }
          return false
        case 'checkbox':
          if (relevance.front === 'choice') {
            if (relevance.ending === 'one_of') {
              for (var ofIdx in data.value[question.title]) {
                if (this.inArray(data.value[question.title][ofIdx], relevance.value)) {
                  return true
                }
              }
              return false
            } else if (relevance.ending === 'all') {
              var bool = true
              for (var allIdx in data.value[question.title]) {
                bool = bool && this.inArray(data.value[question.title][allIdx], relevance.value)
              }
              return bool
            }
          } else if (relevance.front === 'no_choice') {
            if (relevance.ending === 'one_of') {
              for (var ofIdx2 in data.value[question.title]) {
                if (this.inArray(data.value[question.title][ofIdx2], relevance.value)) {
                  return false
                }
              }
              return true
            } else if (relevance.ending === 'all') {
              var bool2 = true
              for (var allIdx2 in data.value[question.title]) {
                bool2 = bool && this.inArray(data.value[question.title][allIdx2], relevance.value)
              }
              return !bool2
            }
          }
          return false
        default:
          return false
      }
    },
    isShow (question) {
      if (question.hide === true) {
        if (question.relevance) {
          var bool = question.relevance.relation === 'and'
          for (var idx in question.relevance.list) {
            var pidObj = question.relevance.list[idx].qid.split('-')
            if (!this.question[pidObj[0]] && this.question[pidObj[0]].title !== question.relevance.list[idx].qid.substr((pidObj[0] + '-').length)) {
              return false
            }
            if (question.relevance.relation === 'and') {
              bool = bool && this.checkRelevance(this.question[pidObj[0]], this.post[pidObj[0]], question.relevance.list[idx])
            } else {
              bool = bool || this.checkRelevance(this.question[pidObj[0]], this.post[pidObj[0]], question.relevance.list[idx])
            }
          }
          return bool
        }
        return false
      }
      return true
    },
    setPost () {
      var post = []
      for (var idx in this.question) {
        var item = this.question[idx]
        var _item = {}
        _item['title'] = item.title
        _item['from_type'] = item.from_type
        _item['value'] = {}
        switch (item.from_type) {
          case 'user_name':
            _item['value']['昵称'] = this.member.nickname
            _item['value']['部门'] = this.member.department_name
            break
          case 'rate':
            _item['value'][item.title] = parseInt(this.question[idx].def_value)
            break
          default:
            _item['value'][item.title] = this.question[idx].def_value
            break
        }
        if (this.question[idx].value_enumeration) {
          _item['extra'] = {}
          for (var i in this.question[idx].value_enumeration) {
            _item['extra'][this.question[idx].value_enumeration[i]] = ''
          }
        }
        post.push(_item)
      }
      this.$set(this, 'post', post)
    },
    getProject () {
      var timestamp = Date.parse(new Date())
      this.$http.get(this.apiroot + '/open/project?id=' + this.projectId + '&puid=' + this.projectUid + '&' + timestamp).then((response) => {
        this.loadding = false
        this.$set(this, 'project', response.data.data.project)
        this.$set(this, 'authorize', response.data.data.authorize)
        this.$set(this, 'formwork', response.data.data.formwork)
        this.$set(this, 'formwork_attr', response.data.data.formwork_attr)
        this.$set(this, 'member', response.data.data.member)
        this.$set(this, 'ui', response.data.data.ui)
        this.$set(this, 'question', response.data.data.question)
        if (this.authorize) {
          this.init(this.authorize.id)
        }
        this.setPost()
        this.$Spin.hide()
        this.getLastPostData()
      })
    },
    getLastPostData () {
      var postData = {}
      postData['sign'] = 'questionnaire'
      postData['action'] = 'getLastPostData'
      postData['project_id'] = this.projectId
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        if (response.data.code === 1) {
          if (response.data.data && response.data.data.post_data) {
            this.isPost = true
            this.postAt = response.data.data.created_at
            for (var idx in this.post) {
              if (this.post[idx] && response.data.data.post_data[idx] && this.post[idx].title === response.data.data.post_data[idx].title) {
                var post = response.data.data.post_data[idx]
                if (post.from_type === 'address') {
                  if (JSON.stringify(post.value) === '[]') {
                    post.value = {}
                  }
                }
                this.$set(this.post, idx, post)
              }
            }
            Notify({ type: 'primary', message: '你于' + this.postAt + '已经提交过了！' })
          }
        }
      })
    },
    getFormatList () {
      var postData = {}
      postData['sign'] = 'questionnaire'
      postData['action'] = 'getFormatList'
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        if (response.data.code === 1) {
          for (var idx in response.data.data) {
            this.formatList[response.data.data[idx].value] = response.data.data[idx]
          }
        }
      })
    },
    doFormatValue (key, value) {
      if (this.formatList[key].format) {
        return value.match(this.formatList[key].format)
      }
      return true
    },
    checkPost (rowIdx) {
      var ret = true
      var checkList = {}
      for (var idx in this.question) {
        if (this.question[idx].from_type === 'user_name' || this.question[idx].from_type === 'wechat_name') {
          continue
        }
        if (rowIdx === false || '' + rowIdx === '' + idx) {
          if (this.question[idx].from_type === 'radio') {
            var isIn = false
            for (var _enumIdx in this.question[idx].value_enumeration) {
              if (this.post[idx].value[this.question[idx].title] === this.question[idx].value_enumeration[_enumIdx]) {
                isIn = true
              }
            }
            if (!isIn) {
              checkList['r_' + idx] = this.question[idx].title + '选项选择错误，请重新选择'
            }
          }

          if (this.question[idx].required) {
            if (this.question[idx].from_type === 'date') {
              if (!this.post[idx].value[this.question[idx].title]) {
                ret = false
                checkList['r_' + idx] = this.question[idx].title + '必填'
              }
            } else if (typeof this.post[idx].value[this.question[idx].title] === 'object') {
              if (!this.post[idx].value[this.question[idx].title][0]) {
                ret = false
                checkList['r_' + idx] = this.question[idx].title + '必填'
              }
            } else {
              if (!this.post[idx].value[this.question[idx].title]) {
                ret = false
                checkList['r_' + idx] = this.question[idx].title + '必填'
              }
            }
          }
          if (this.question[idx].inputs_required) {
            for (var enumIdx in this.question[idx].value_enumeration) {
              if (this.inArray(this.question[idx].value_enumeration[enumIdx], this.post[idx].value[this.question[idx].title])) {
                if (this.question[idx].inputs_required[enumIdx]) {
                  if (!this.post[idx].extra[this.question[idx].value_enumeration[enumIdx]]) {
                    ret = false
                    checkList['r_' + idx] = this.post[idx].extra[this.question[idx].value_enumeration[enumIdx]] + '附加输入必填'
                  }
                }
              }
            }
          }

          if (this.question[idx].title && this.post[idx].value[this.question[idx].title] && this.question[idx].value_check) {
            if (this.question[idx].value_check.format !== '') {
              if (!this.doFormatValue(this.question[idx].value_check.format, this.post[idx].value[this.question[idx].title])) {
                ret = false
                checkList['r_' + idx] = '请输入正确的' + this.formatList[this.question[idx].value_check.format].name
              }
            }
            if (ret) {
              if (this.question[idx].value_check.min_length !== null || this.question[idx].value_check.max_length !== null) {
                if (this.formatList[this.question[idx].value_check.format].length) {
                  if (this.post[idx].value[this.question[idx].title].length - this.question[idx].value_check.min_length < 0) {
                    ret = false
                    checkList['r_' + idx] = this.question[idx].title + '字数至少' + this.question[idx].value_check.min_length + '位'
                  } else if (this.post[idx].value[this.question[idx].title].length - this.question[idx].value_check.max_length > 0) {
                    ret = false
                    checkList['r_' + idx] = this.question[idx].title + '字数最多' + this.question[idx].value_check.max_length + '位'
                  }
                }
              }
            }
          }
          if (rowIdx !== false) {
            this.$set(this.checkList, 'r_' + idx, checkList['r_' + idx])
          }
        }
      }
      if (rowIdx === false) {
        this.$set(this, 'checkList', checkList)
      }
      return ret
    },
    submit () {
      if (this.checkPost(false)) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          message: '提交中...'
        })
        var postData = {}
        postData['sign'] = 'questionnaire'
        postData['action'] = 'postData'
        postData['project_id'] = this.projectId
        postData['data'] = {}
        postData['data']['project_uri_id'] = this.projectUid
        postData['data']['post_data'] = this.post
        console.log(postData)
        this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
          Toast.clear()
          if (response.data.code === 1) {
            Toast.success('提交成功')
          } else {
            Toast.fail('提交失败' + (response.data.message ? '，' + response.data.message + '。' : '。'))
          }
        })
      }
    },
    init (authorizeId) {
      if (window.kkWeChat) {
        var project = this.project
        var url = this.project.url + '?shareId=' + (this.member.id ? this.member.id : 'none')
        var me = this
        window.kkWeChat.init(authorizeId, function () {
          window.kkWeChat.setShare(url, project, function (doing, status, res) {
            me.triggerShare(doing, status, res)
          })
        })
      }
    },
    triggerShare (doing, status, res) {
      var postData = {}
      postData['UID'] = this.member['UID']
      postData['id'] = this.projectId
      postData['pu_id'] = this.projectUid
      postData['status'] = status === 1 ? 200 : 209
      this.$http.post(this.apiroot + '/open/share', postData).then((response) => {
        if (response.data.code) {
          if (status === 1) {
            this.$Message.success('分享成功')
          } else {
            this.$Message.info('取消分享')
          }
        }
      })
    }
  },
  mounted () {
    this.projectId = window.pid
    if (this.projectId === '{{ $projectId }}') {
      this.projectId = '114'
    }
    this.projectUid = window.puid
    if (this.projectUid === '{{ $projectUid }}') {
      this.projectUid = '148'
    }
    this.$Spin.show()
    this.getFormatList()
    this.getProject()
  }
}
</script>
<style>
.w-100 { width: 100px; }
.text-top-right, .text-bottom-right { text-align: right !important; }
.text-top-center, .text-bottom-center { text-align: center !important; }
.text-top-left, .text-bottom-left { text-align: left !important; }
.van-address-list { overflow: auto; }
.kk-content img { max-width: 100%; }
</style>



// WEBPACK FOOTER //
// src/App.vue